module.exports = __webpack_public_path__ + "img/167.0c268746.jpg";